// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Select {\n  outline: none;\n}\n.Select-control {\n  box-shadow: none !important;\n}\n", "",{"version":3,"sources":["webpack://./app/uikit/input/SelectInput.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACA;EACE,2BAAA;AACF","sourcesContent":[".Select {\n  outline: none;\n}\n.Select-control {\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
